export default __webpack_public_path__ + "static/media/gold_overlay.6af5e0d9.png";